import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
const AcademicCalendar = () => {
  useEffect(() => {
    document.title = "Academic Calendar - St. Francis Xavier School";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li>About Us</li>
        </ul>
      </div>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 mand_dis_sec">
              {/* <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/ANNUAL-ACADEMIC-CALENDAR.jpg"
                  className="img-fluid mx-auto d-block"
                  alt="sfxhisar"
                />
              </LazyLoad> */}
            <iframe src='https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SFXH/public/pdf/ANNUAL-ACADEMIC-CALENDAR.pdf' width="100%" height="500" title="Last 3 Year Result" rel="noreferrer"></iframe>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AcademicCalendar;
